import { render, staticRenderFns } from "./create-asset-type-dialog.vue?vue&type=template&id=491408b0&scoped=true&"
import script from "./create-asset-type-dialog.vue?vue&type=script&lang=js&"
export * from "./create-asset-type-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491408b0",
  null
  
)

export default component.exports